import { connect } from 'react-redux';
import {
  updateOrganizationFieldAction,
  createOrganizationwindowOpenAction,
  createOrganizationWinndowCloseAction,
  loadAnalystsListRequestAction,
  addAttendee,
  removeAttendee,
  updateOrganizationAttendee,
} from '@actions/organizations';
import {
  selectOrganizationsEditForm,
  selectOrganizationsRules,
  selectAnalystsList,
} from '@selectors/organizations';
import { selectIntroMessagesList } from '@selectors/introMessages';

import { selectNumbersByCountries } from '@selectors/countries';
import OrganizationInformationForm from './OrganizationInformationForm';

const mapStateToProps = (state) => ({
  organizationsEditForm: selectOrganizationsEditForm(state),
  allRules: selectOrganizationsRules(state),
  fullAnalystsList: selectAnalystsList(state),
  numbersByCountries: selectNumbersByCountries(state),
  introMessages: selectIntroMessagesList(state),
});

const mapDispatchToProps = {
  updateOrganizationField: updateOrganizationFieldAction,
  windowOpen: createOrganizationwindowOpenAction,
  winndowClose: createOrganizationWinndowCloseAction,
  loadAnalysts: loadAnalystsListRequestAction,
  addAttendee,
  removeAttendee,
  updateOrganizationAttendee,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(OrganizationInformationForm);



// WEBPACK FOOTER //
// ./components/templates/OrganizationInformationForm/index.js